import {ITriggerStore} from '../../../dashboard/shared';
import * as trigger from '../actions/trigger.action';

export interface State {
  entities: { [deviceUuid: string]: ITriggerStore };
  isTriggerSetting: boolean;
  isTriggerRetrieving: boolean;
}

export const initialState: State = {
  entities: {},
  isTriggerSetting: false,
  isTriggerRetrieving: false
};

/**
 * Because our object state tree is read-only, our response for every action
 * must return a new state object without mutating the previous state object.
 */

export function reducer(state = initialState, action: trigger.Actions): State {
  switch (action.type) {
    // Retrieve Trigger Actions
    case trigger.RETRIEVE_SUCCESS: {
      const payload = <{
        entities: { [deviceUuid: string]: ITriggerStore }
      }>action.payload;

      return {...state, entities: {...payload.entities}, isTriggerRetrieving: false};
    }

    case trigger.START_RETRIEVING_TRIGGER: {
      return {...state, isTriggerRetrieving: true};
    }

    case trigger.RETRIEVE_FAIL: {
      alert('Failed to Retrieve Trigger.\nPlease try again later.');
      return {...state, isTriggerRetrieving: false};
    }

    // Set Trigger Actions
    case trigger.SET_TRIGGER_SUCCESS: {
      return {...state, isTriggerSetting: false};
    }

    case trigger.START_SETTING_TRIGGER: {
      return {...state, isTriggerSetting: true};
    }

    case trigger.SET_TRIGGER_FAIL: {
      alert('Failed to Set Trigger.\nPlease try again later.');
      return {...state, isTriggerSetting: false};
    }

    default:
      return state;
  }
};

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const getEntities = (state: State) => state.entities;

export const getRetrievingStatus = (state: State) => state.isTriggerRetrieving;
export const getSettingStatus = (state: State) => state.isTriggerSetting;
